import { useDispatch } from "react-redux";
import {
  setCurrentPage,
  setSearchTerm,
  setRowsPerPage,
  fetchingData,
  fetchDataSuccess,
  fetchDataFail,
  reloadDialogState,
} from "./_reducers";
import ApiRequest from "../../utils/apiRequest";
import { API_URL } from "../../configs/_api";

const useOtpActions = () => {
    const dispatch = useDispatch();

    async function getOtpbyPhoneNumber( phoneNo ){
        dispatch(fetchingData());
        const url = `${API_URL.Otp}/search?phone_no=${phoneNo}`;

        try {
            const res = await ApiRequest.get(url);
            const data = res.data.payload.data;
            dispatch(fetchDataSuccess({}));
            return data;
        } catch (err) {
            const errMsg = err.response?.data.errors?.message ??  `${err.message}`
            dispatch(fetchDataFail(errMsg))
            return Promise.reject(errMsg);
        }
    }

    function changeSearchTerm(search_key) {
        dispatch(setCurrentPage(0));
        dispatch(setSearchTerm(search_key));
    }

    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }

    function refreshDialogState() {
        dispatch(reloadDialogState());
    }

    return {
        // Actions
        getOtpbyPhoneNumber,

        changeSearchTerm,
        changeCurrentPage,
        changeRowsPerPage,
        refreshDialogState
    };
};

export default useOtpActions;
